/* Adds offer synchronization to the existing native Shopify product forms. */
(() => {
  if (window.JJEvergreenReview) return;
  window.JJEvergreenReview = true;
  let offer = 'kit';
  let frame = 0;
  let dockVisible = false;
  const setDockVisible = (visible) => {
    const dock = document.querySelector('[data-ev-dock]');
    if (!dock) return;
    dockVisible = visible;
    if (!dock.hasAttribute('data-ev-dock-animated')) { dock.hidden = !visible; return; }
    dock.hidden = false;
    dock.classList.toggle('is-visible', visible);
    dock.inert = !visible;
    dock.setAttribute('aria-hidden', String(!visible));
  };
  const all = (selector) => Array.from(document.querySelectorAll(selector));
  const data = () => { try { return JSON.parse(document.querySelector('[data-ev-variants]')?.textContent || '{}'); } catch (_) { return {}; } };
  const selectOffer = (value) => {
    offer = value === 'single' ? 'single' : 'kit';
    all('[data-ev-choice] .jj-ev-choice__radio').forEach((input) => { input.checked = input.value === offer; });
    all('[data-ev-gallery-kit]').forEach((node) => { node.hidden = offer !== 'kit'; });
    all('[data-ev-gallery-single]').forEach((node) => { node.hidden = offer !== 'single'; });
    all('[data-ev-dock-kit]').forEach((node) => { node.hidden = offer !== 'kit'; });
    all('[data-ev-dock-single]').forEach((node) => { node.hidden = offer !== 'single'; });
    all('[data-ev-dock-title]').forEach((node) => { node.textContent = offer === 'kit' ? (node.closest('[data-ev-dock-animated]') ? 'Starter Kit' : 'Tomorrow’s Starter Kit') : 'NRGStripz'; });
    all('[data-ev-dock-detail]').forEach((node) => { node.hidden = offer !== 'kit'; });
    all('[data-ev-single-note]').forEach((node) => { node.hidden = offer !== 'single'; });
    scheduleDock();
  };
  const syncPrice = (detail = {}) => {
    const variant = (data().variants || []).find((item) => String(item.id) === String(detail.id));
    if (!variant) return;
    all('[data-ev-kit-image]').forEach((img) => {
      const next = detail.image || (detail.useGalleryDefault ? img.dataset.defaultSrc : '');
      if (next) {
        const source = new URL(next, location.origin);
        if (img.closest('[data-ev-dock]')) source.searchParams.set('width', '160');
        img.src = source.href; img.removeAttribute('srcset');
      }
      img.alt = `${variant.title} bottle and one 30-strip NRGStripz tin`;
    });
    all('[data-ev-kit-price]').forEach((node) => { node.textContent = variant.price; });
    all('.jj-evergreen [data-jj-variant-input]').forEach((input) => {
      const button = input.closest('form')?.querySelector('button[name=add]');
      if (!button) return;
      button.dataset.jjAvailableLabel = button.closest('[data-ev-dock-animated]') ? `Add kit · ${variant.price}` : `Add Starter Kit · ${variant.price}`;
      const label = button.querySelector('.btn-text');
      if (label) label.textContent = variant.available ? button.dataset.jjAvailableLabel : 'Sold out';
      button.disabled = !variant.available;
    });
    // Preserve the preview parameter and selected color when the page is shared.
    try { const url = new URL(window.location.href); url.searchParams.set('variant', String(variant.id)); history.replaceState(history.state, '', url); } catch (_) {}
    all('[data-jj-variant-slide]').forEach((slide) => { slide.setAttribute('aria-label', `${variant.title} bottle and 30 NRGStripz. Kit total ${variant.price}.`); });
  };
  const syncDock = () => {
    frame = 0;
    const dock = document.querySelector('[data-ev-dock]');
    const hero = document.querySelector('[data-ev-hero]');
    if (!dock || !hero) return;
    const panel = hero.querySelector(offer === 'kit' ? '.jj-ev-choice__kit' : '.jj-ev-choice__single');
    const button = panel?.querySelector('button[name=add]');
    const final = document.getElementById('jj-paid-offer');
    const finalRect = final?.getBoundingClientRect();
    const finalVisible = finalRect && finalRect.top < window.innerHeight - 64;
    const drawer = document.querySelector('cart-drawer:not([hidden]), menu-drawer:not([hidden]), search-drawer:not([hidden]), modal-element:not([hidden]), dialog[open], [role=dialog][aria-modal=true]:not([hidden])');
    const keyboardOpen = window.visualViewport && window.visualViewport.height < window.innerHeight * .72;
    const heroBottom = button?.getBoundingClientRect().bottom ?? Infinity;
    const heroPassed = heroBottom < (dockVisible ? 8 : -24);
    setDockVisible(Boolean(button && heroPassed && !finalVisible && !drawer && !keyboardOpen));
  };
  function scheduleDock() { if (!frame) frame = requestAnimationFrame(syncDock); }
  const init = () => {
    all('[data-ev-choice] .jj-ev-choice__radio').forEach((input) => {
      if (input.dataset.evBound) return;
      input.dataset.evBound = 'true';
      input.addEventListener('change', () => { if (input.checked) selectOffer(input.value); });
    });
    const requested = new URLSearchParams(location.search).get('variant');
    const options = all('[data-jj-variant-option]');
    const initial = options.find((input) => input.value === requested && !input.disabled) || options.find((input) => input.checked && !input.disabled);
    if (initial) { initial.checked = true; initial.dispatchEvent(new Event('change', { bubbles: true })); syncPrice({ id: initial.value }); }
    selectOffer(offer);
    all('[data-ev-video]').forEach((video) => {
      if (video.dataset.evBound) return;
      video.dataset.evBound = 'true';
      if ('IntersectionObserver' in window) new IntersectionObserver((entries) => { entries.forEach((entry) => { if (!entry.isIntersecting) video.pause(); }); }).observe(video);
    });
    document.querySelectorAll('cart-drawer, modal-element, menu-drawer, search-drawer, dialog').forEach((dialog) => {
      if (dialog.dataset.evObserved) return;
      dialog.dataset.evObserved = 'true';
      new MutationObserver(scheduleDock).observe(dialog, { attributes: true, attributeFilter: ['hidden', 'open', 'class'] });
    });
    scheduleDock();
  };
  document.addEventListener('jj:variant-change', (event) => syncPrice(event.detail));
  window.addEventListener('scroll', scheduleDock, { passive: true });
  window.addEventListener('resize', scheduleDock, { passive: true });
  window.visualViewport?.addEventListener('resize', scheduleDock, { passive: true });
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('cart:open', () => setDockVisible(false));
  document.addEventListener('jj:overlay-change', scheduleDock);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true }); else init();
})();
